import React, { createContext, useState } from 'react';
import { ClientStore } from '../../../Store/StoresObjects/ClientStore';
import { ServerStore } from '../../../Store/StoresObjects/ServerStore';

interface IStoreContext {
  store?: ServerStore | ClientStore;
  setStore?: React.Dispatch<React.SetStateAction<ServerStore | ClientStore>>;
}

export const StoreContext = createContext<IStoreContext>({});

export const StoreProvider = (props) => {
  const [store, setStore] = useState<ServerStore | ClientStore>(props.store);
  return (
    <StoreContext.Provider value={{ store, setStore }}>
      {props.children}
    </StoreContext.Provider>
  );
};

StoreProvider.displayName = 'StoreProvider';

export const StoreConsumer = StoreContext.Consumer;
